"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombineProviders = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const CombineProviders = ({ children, providers }) => providers.filter(Boolean).reduceRight((result, item) => {
    const { provider: Provider } = item, otherProps = tslib_1.__rest(item, ["provider"]);
    return (0, react_1.createElement)(Provider, otherProps, result);
}, (0, react_1.createElement)(react_1.Fragment, undefined, children));
exports.CombineProviders = CombineProviders;
//# sourceMappingURL=index.js.map